/* hs-eslint ignored failing-rules */

/* eslint-disable no-prototype-builtins */
'use es6';

import Immutable from 'immutable';
import ProfileListing from 'ecosystem-marketplace-core/records/ProfileListing';
import { searchProfiles } from '../clients/profilesClient';
import * as ActionTypes from './ActionTypes';
import { maybeEarlyRequest } from '../utils/earlyRequests';
export const fetchProfiles = (query = {
  limit: 45
}) => dispatch => {
  dispatch({
    type: ActionTypes.STOREFRONT_PROFILES_REQUESTED
  });
  return maybeEarlyRequest('storefront-search', () => searchProfiles(query)).then(resp => {
    const profiles = Immutable.List( // TODO eventual multi search
    resp[0].items.map(item => ProfileListing.from(item)));
    dispatch({
      type: ActionTypes.STOREFRONT_PROFILES_RECEIVED,
      payload: profiles,
      meta: {
        total: resp[0].total
      }
    });
    return resp;
  }).catch(error => {
    dispatch({
      type: ActionTypes.STOREFRONT_PROFILES_FAILED,
      payload: error
    });
  });
};